// extracted by mini-css-extract-plugin
export default {"leftFilter":"LeftFilterVersionStructure_leftFilter__a5XY5"};